import { useEffect, useState } from "react";
import FontFaceObserver from "fontfaceobserver";

export const useFontLoaded = (fontName: string) => {
    const [fontLoaded, setFontLoaded] = useState(false);
    useEffect(() => {
        const observer = new FontFaceObserver(fontName);
        void observer.load().then(() => {
            setFontLoaded(true);
        });
    }, []);

    return fontLoaded;
};
